module.exports = __webpack_public_path__ + "static/media/A7S01547.05a0ee16.jpg";